import React, { useEffect, useLayoutEffect, useState } from 'react';
import './progessbar.css';

const ProgessBarr = ({ percentageGraded, course }) => {
  const [barHeight, setBarHeight] = useState(0); // Start with 0

  useLayoutEffect(() => {
    if (percentageGraded >= 0 && percentageGraded <= 100) {
      // Set the bar height based on percentage
      setBarHeight(percentageGraded);
    }
  }, [percentageGraded]); // Update the bar height whenever percentageGraded changes

  return (
    <div className='progress-container-one'>
      <div className='progress-bar-one'>
        <div
          className={`label-font ${percentageGraded === 0 ? 'bar-one-empty' : 'bar-one'}`}
          style={{ height: percentageGraded > 0 && barHeight, width: '100%' }}
          // Use percentage as height
        >
          <span
            className={` ${
              percentageGraded < 40 && percentageGraded > 0 ? 'progress-label-one' : ''
            }`}
          >
            {percentageGraded === 0 ? `--` : percentageGraded}%{' '}
          </span>

          {/* Show percentage inside the bar */}
        </div>
        <div
          className='ft_16 fw-600 range_heading mb-0'
          style={{
            width: '100%',
            marginTop: percentageGraded === 0 ? '6px' : '0px',
          }}
        >
          <span style={{ width: '100%' }}>
            {course?.courseNumber?.slice(0, 5)} {/* Display first word of course name */}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProgessBarr;
